/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { date, DateFormat, entity } from '@gh/core-data';
import { XeroIssueLogDto } from './xero-issue-log.dto';

export const XeroIssueLogMapper = entity<XeroIssueLogDto>({
  issueDate: date(DateFormat.DateTime),
});
